<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Link } from '@inertiajs/vue3'
import logo from '@/../images/logo.jpg'
import Header from '@pages/home/components/Header.vue'

const isScrolled = ref(false)
const mobileMenuOpen = ref(false)
const form = ref({ name: '', email: '', message: '' })

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}
onMounted(() => window.addEventListener('scroll', handleScroll))
onBeforeUnmount(() => window.removeEventListener('scroll', handleScroll))

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

const submitForm = () => {
  alert(`Message sent successfully!\n\nName: ${form.value.name}`)
  form.value = { name: '', email: '', message: '' }
}
</script>

<template>
  <div class="relative">
    <!-- ======= Header / Navbar ======= -->
    <Header />

    <!-- Hero -->
    <section class="bg-primary-100 py-24 text-center mt-16">
      <h2 class="text-4xl font-bold text-primary-700 mb-4">Contact Us</h2>
      <p class="max-w-2xl mx-auto text-gray-600 text-lg">
        We’d love to hear from you. Get in touch for inquiries, admissions, or partnership opportunities.
      </p>
    </section>

    <!-- Contact Section -->
    <section class="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10">
      <!-- Contact Form -->
      <div class="bg-white rounded-2xl shadow p-8">
        <h3 class="text-2xl font-semibold text-primary-700 mb-6">Send Us a Message</h3>
        <form @submit.prevent="submitForm" class="space-y-5">
          <input
            v-model="form.name"
            type="text"
            placeholder="Your Name"
            required
            class="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-secondary-500 outline-none"
          />
          <input
            v-model="form.email"
            type="email"
            placeholder="Your Email"
            required
            class="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-secondary-500 outline-none"
          />
          <textarea
            v-model="form.message"
            rows="5"
            placeholder="Your Message"
            required
            class="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-secondary-500 outline-none"
          ></textarea>
          <button
            type="submit"
            class="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-full shadow-lg transition-all"
          >
            Send Message
          </button>
        </form>
      </div>

      <!-- Google Map -->
      <div class="rounded-2xl overflow-hidden shadow">
        <iframe
          class="w-full h-full min-h-[400px]"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3941.6874976161653!2d9.857!3d10.315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1061e6b0a1f!2sBauchi!5e0!3m2!1sen!2sng!4v1702912399123!5m2!1sen!2sng"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
    <Footer />
  </div>
</template>
